import {
  ActionButton,
  Button,
  Text,
  H3,
  ChevronLeftIcon,
} from '@/components/atoms'
import { OtpInput } from '@/components/molecules/otp-input'
import { OTP_LENGTH } from '@/components/molecules/otp-input/constants'
import { AppHeader, ResendOtp } from '@/components/molecules'
import { useTranslation } from 'react-i18next'
import { useVerifyCodePage } from './page.verify-code.hook'
import { verifyCodeImage } from '@/shared/assets'

export function VerifyCodePage() {
  const { t } = useTranslation()
  const {
    email,
    emailParam,
    otp,
    setOtp,
    error,
    loadingVerify,
    otpResetKey,
    handleOtpSubmit,
    handleResendOtp,
    handleBack,
  } = useVerifyCodePage()

  return (
    <div className="flex min-h-full flex-col">
      <AppHeader variant="auth" />

      <div className="flex flex-1 flex-col-reverse overflow-hidden md:flex-row md:overflow-x-auto">
        <div className="relative z-0 flex h-133 flex-1 items-center justify-end md:h-auto">
          <img
            src={verifyCodeImage}
            width={445}
            height={535}
            alt="Kanguro"
            className="absolute top-0 right-[max(calc(50dvw-174px),0px)] object-cover md:relative md:left-0"
          />
        </div>

        <div className="flex items-start px-6 py-10 md:flex-1 md:items-center md:px-16">
          <div className="flex w-full flex-col items-start gap-6 md:max-w-123.5">
            <div className="flex w-full items-center">
              {!emailParam && (
                <ActionButton
                  variant="tertiary"
                  size="sm"
                  className="stroke-2"
                  icon={ChevronLeftIcon}
                  onClick={handleBack}
                  disabled={loadingVerify}
                  aria-label={t('login.back')}
                  title={t('login.back')}
                  data-testid="back-button"
                />
              )}
              <H3>{t('login.otp.title')}</H3>
            </div>

            <div className="flex w-full flex-col gap-6 md:pl-8">
              <Text className="text-xl leading-6">
                {t('login.otp.descriptionStart')}
                {email}.
                <br />
                {t('login.otp.descriptionEnd')}
              </Text>

              <div className="flex w-full flex-col gap-4">
                <OtpInput
                  key={otpResetKey}
                  onChange={setOtp}
                  loading={loadingVerify}
                />
                {error && (
                  <Text
                    data-testid="otp-error"
                    className="text-error-base text-sm"
                  >
                    {error}
                  </Text>
                )}
              </div>

              <div className="flex w-full flex-col items-stretch justify-start gap-4 md:flex-row">
                <Button
                  variant="primary"
                  onClick={() => handleOtpSubmit(otp)}
                  disabled={loadingVerify || otp.length < OTP_LENGTH}
                  loading={loadingVerify}
                  data-testid="verify-button"
                  className="w-full md:max-w-65.5"
                >
                  {t('login.otp.verify')}
                </Button>
                <ResendOtp onResend={handleResendOtp} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
